<template>
  <div :class="$style.root">
    <div
      :class="{
        [$style.introButton]: true,
        [$style.introButton_atTop]: !isIntroVideoPlayed,
      }"
      @click="playIntroVideo"
    >
      遊戲教學
      <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/video.svg')" />
    </div>

    <AnicssGroup
      :class="$style.thumbs"
      tag="div"
      :enter-active-class="['animated', 'fadeInUp']"
      appear
    >
      <template v-for="({ title, to, ...thumb }, n) in thumbs">
        <Link
          :to="to"
          :class="$style.thumb"
          :key="title"
          :style="{'animation-delay': `${n * 200}ms`}"
        >
          <TitleThumb v-bind="thumb">
            {{ title }}
          </TitleThumb>
        </Link>
        <div :key="`break-${n}`" :class="$style.flexBreak" v-if="n % 2 == 1"></div>
      </template>
    </AnicssGroup>

    <Link :to="{ name: 'progress' }" :class="$style.progressCheck">
      <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/progress-check.svg')" />
    </Link>

    <VideoPlayer
      ref="player"
      v-show="isIntroVideoActive"
      :files="videoFiles"
      @close="closeIntroVideo"
      @ended="closeIntroVideo"
    />

    <Welcome
      v-if="!isIntroVideoPlayed"
      @close="skipIntro"
    />
  </div>
</template>

<script>
import TitleThumb from '@/components/TitleThumb'
import Link from '@/components/Link'
import AnicssGroup from '@/components/AnicssGroup'
import SvgIcon from '@/components/SvgIcon'
import { mapState } from 'vuex'
import VideoPlayer from '@/components/VideoPlayer'
import Welcome from '@/components/Landing/Welcome'

const getIntroPlayed = () => {
  return !!localStorage.getItem('intro_video_played')
}

const setIntroPlayed = (flag) => {
  localStorage.setItem('intro_video_played', flag)
}

export default {
  components: {
    TitleThumb,
    Link,
    AnicssGroup,
    SvgIcon,
    VideoPlayer,
    Welcome,
  },
  data () {
    return {
      videoFiles: [require('!file-loader!@/assets/video/intro.mp4')],
      isIntroVideoActive: false,
      isIntroVideoPlayed: getIntroPlayed(),
    }
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'thumbs',
    ]),
  },
  methods: {
    playIntroVideo () {
      this.isIntroVideoActive = true
      this.setInroPlayed()
      this.$refs.player.play()
    },
    closeIntroVideo () {
      this.isIntroVideoActive = false
      this.$refs.player.stop()
    },
    skipIntro () {
      this.setInroPlayed()
    },
    setInroPlayed () {
      this.isIntroVideoPlayed = true
      setIntroPlayed(true)
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply w-full;
  @apply h-full;
  @apply flex;
  @apply flex-col;
  @apply justify-center;
}

.flexBreak {
  flex-basis: 100%;
}

.thumbs {
  @apply flex;
  @apply flex-wrap;
  @apply content-center;
  @apply justify-center;
}

.thumb {
  @apply m-4;
  @apply no-underline;

  &:active {
    transition: transform .2s;
    transform: scale(0.95);
  }
}

.progressCheck {
  @apply absolute;
  @apply bottom-0;
  @apply right-0;
  @apply m-8;
}

.introButton {
  font-size: 2.5rem;
  @apply self-center;
  color: #ef9c57;
  border: 4px solid #ef9c57;
  padding: 0.5rem 7rem;
  @apply flex;
  @apply items-center;
  @apply cursor-pointer;
  transition: all .3s;
  position: relative;

  &:hover {
    transform: scale(1.03);
  }
  &:active {
    color: #d78a4a;
    border-color: #d78a4a;
    transform: scale(0.97);
  }
}

.introButton_atTop {
  z-index: 999999;
}
</style>
